import $ from 'jquery';
import URI from 'urijs';
import * as infiniteHits from './load_more_results';
import { safeAddWidgets } from './base_widgets';

window.Products = {
  initializeWidgets(user_id, company_id, app_id, key, index, tag, userTag, sortByIndices, category, product_attributes, controller) {
    if ($('#products-list-container').length === 0) {
      return;
    }
    const FACET_CONFIG = product_attributes;
    const searchParameters = {
      facets: ['dynamic_attributes'],
      disjunctiveFacets: ['manufacturer', 'supplier', 'user_tags'],
      filters: ProductWidgets.getQuery(user_id, company_id, controller)
    };

    $.each(FACET_CONFIG, function (key, value) {
      searchParameters['disjunctiveFacets'].push(value.parentAttribute + '.' + key);
    });

    if (category || userTag) {
      const tagAttributeName = `user_tags.${user_id}`;
      searchParameters['facets'].push(tagAttributeName);
      searchParameters['facetsRefinements'] = {};
      searchParameters['facetsRefinements'][tagAttributeName] = [userTag];
      searchParameters['hierarchicalFacetsRefinements'] = { 'categories.lvl0': [category] };
    }

    const productsSearch = SearchUtils.createInstantSearch(app_id, key, index);

    const widgets = [
      instantsearch.widgets.configure(searchParameters),
      () => ProductWidgets.hitsWidget(user_id, company_id),
      () => ProductWidgets.categoryWidget(),
      () => ProductWidgets.manufacturerWidget(),
      () => ProductWidgets.supplierWidget('supplier'),
      () => ProductWidgets.certificatesWidget(),
      () => ProductWidgets.collectionWidget(),
      () => Widgets.descriptionWidget('#description', ['title', 'model_number'], 'description'),
      () => Widgets.currentRefinedValuesWidget()({ excludedAttributes: [] }),
      () => Widgets.statsWidget(),
      () => Widgets.searchBoxWidget('Enter keyword(s)'),
      () => ProductWidgets.quickListWidget(user_id, company_id),
      () => Widgets.clearAllWidget()
    ];

    if ($('#refinement-lists').length > 0) { widgets.push(() => Widgets.dynamicFacetsWidget(product_attributes)); }
    if ($('#user-tags').length > 0) { widgets.push(() => Widgets.userTagsWidget(user_id)); }
    if ($('#certificates').length > 0) { widgets.push(() => Widgets.certificatesWidget()); }
    if ($('#sort-by-container').length > 0) { widgets.push(() => Widgets.sortBySelectorWidget(sortByIndices)); }
    if ($('#save-search').length > 0) { widgets.push(() => Widgets.saveSearchWidget()); }

    safeAddWidgets(productsSearch, widgets);
    productsSearch.start();
    infiniteHits.loadMoreResults();
    this._initializeSaveSearch();

    return productsSearch.on('render', function () {
      if (user_id) { SearchUtils.adjustViewMode(); }
      $.cloudinary.responsive();
      window.advancedSearchFixed();
      if (!$('html').is('.platform-layout')) {
        if (savvior.ready(".ais-Hits-list")) {
          savvior.destroy();
        } else {
          setup_gridview();
        }
      }
    });
  },

  _showModalFromUrl(url) {
    return $.get({
      url,
      success(response) {
        $('#filterModal').html(response);
        $('#filterModal').foundation('reveal', 'open');
        return $('#filterModal').foundation('abide', 'reflow');
      }
    });
  },

  _initializeSaveSearch() {
    $('body').on('click', '.flexible-rolldown ul.f-dropdown li', function () {
      return $(this).closest('ul.f-dropdown').find('div.anchor').removeClass('selected');
    });

    $('body').on('click', '.flexible-rolldown > a', function () {
      $('body').off('click', '.flexible-rolldown ul.f-dropdown li.saved_search');
      return $('body').on('click', '.flexible-rolldown ul.f-dropdown li.saved_search', e => window.location = $(e.currentTarget).find('a').first().attr('href'));
    });

    $('#quick-lists a.edit').on('click', e => {
      e.preventDefault();
      e.stopPropagation();
      return this._showModalFromUrl($(e.currentTarget).attr('href'));
    });

    $(document).on('click', '.f-dropdown a.private-choice', function (e) {
      const $target = $(e.currentTarget);
      $('#visibility-content').html($target.html());
      return $('#saved_search_visibility').val($target.data().value);
    });

    return $('#save-search').on('click', 'button', e => {
      e.preventDefault();
      if ($('#signin-modal').length) {
        return $('#signin-modal').foundation('reveal', 'open');
      } else {
        const uri = new URI(window.location);
        const params = { query_params: JSON.stringify(uri.search(true)), type: 'public_products' };
        return this._showModalFromUrl(`/workplace/saved_searches/new?${$.param(params)}`);
      }
    });
  }
};
